import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

class AboutUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: true,
        };
    }

    render() {
        const { isLoaded } = this.state;

        return (
            <div
           
            >
                <section className="about-us">
                    <div className="container" style={{ backgroundColor: 'rgba(255, 255, 255, 0.85)', borderRadius: '12px', padding: '30px' }}>
                        <div className="section-header text-center mb-4">
                            <h2 style={{ color: '#444', fontWeight: '700', fontSize: '36px' }}>About Us</h2>
                        </div>

                        <div className="row justify-content-center">
                            {!isLoaded ? (
                                <div className="text-center">
                                    <CircularProgress color="secondary" />
                                </div>
                            ) : (
                                <div className="col-12">
                                    <div className="about-content">
                                        <h5 style={{ color: '#b85c38' }}>Who We Are</h5>
                                        <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
                                            At <strong>JC Creations</strong>, we are dedicated to delivering an exceptional online shopping experience for our valued customers...
                                        </p>

                                        <h5 style={{ color: '#b85c38' }}>Our Mission</h5>
                                        <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
                                            Our mission is to create innovative, sustainable, and user-friendly products that enhance the lives of our customers.
                                        </p>

                                        <h5 style={{ color: '#b85c38' }}>Our Vision</h5>
                                        <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
                                            We strive to be a leader in our industry by continuously improving our offerings...
                                        </p>

                                        <h5 style={{ color: '#b85c38' }}>Contact Us</h5>
                                        <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
                                            📞 <strong>Phone:</strong> +91 83107 26160 <br />
                                            📧 <strong>Email:</strong> jc.creations99@gmail.com <br />
                                            📍 <strong>Address:</strong> JC Creations, Yelahanka, Bangalore-560064, India
                                        </p>
                                        <p style={{ fontStyle: 'italic', color: '#666' }}>
                                            We'd love to hear your suggestions or comments about our website. For help with downloads, please contact us with your order details.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default AboutUs;
